declare var $: any;

export function setupDemoForm() {
  const submitButton = document.querySelector("input#id_submit.no-captcha") as HTMLInputElement;
  if (!submitButton) {
    return;
  }

  const form = $("form#demo-form");
  form.submit(() => {
    form.find("input[type=submit]")
      .attr("disabled", "disabled")
      .val("Please wait...");
  });
}
